
(() => {
  const selector = '.custom-four-mega';

  function initMegaMenus() {
    document.querySelectorAll(selector).forEach((menu) => {
      if (menu.dataset.hoverInitialized === 'true') return;

      menu.dataset.hoverInitialized = 'true';

      const summary = menu.querySelector(':scope > summary');

      if (!summary) return;

      // Open on mouse hover on desktop.
      menu.addEventListener('mouseenter', () => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          menu.open = true;
        }
      });

      // Close when the pointer leaves, unless keyboard
      // focus is still inside the menu.
      menu.addEventListener('mouseleave', () => {
        if (
          window.matchMedia('(min-width: 990px)').matches &&
          !menu.contains(document.activeElement)
        ) {
          menu.open = false;
        }
      });

      // Keyboard users can open the menu with focus.
      summary.addEventListener('focus', () => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          menu.open = true;
        }
      });

      // Close when keyboard focus leaves the whole menu.
      menu.addEventListener('focusout', (event) => {
        if (
          window.matchMedia('(min-width: 990px)').matches &&
          !menu.contains(event.relatedTarget)
        ) {
          menu.open = false;
        }
      });

      // Escape closes the open menu and returns focus.
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false;
          summary.focus();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initMegaMenus
    );
  } else {
    initMegaMenus();
  }

  // Support Shopify theme editor section reloads.
  document.addEventListener(
    'shopify:section:load',
    initMegaMenus
  );
})();
